module.exports = __webpack_public_path__ + "static/media/infaq4.4a1ea84f.png";